/**
 * invite-link — copy-to-clipboard for the "Invite a colleague" card on /profile/.
 *
 * Progressive enhancement only: the link is already visible and selectable in a
 * readonly input, so a failed copy (older browser, denied permission, non-secure
 * origin) leaves the member with a perfectly usable card. That is why the fallback
 * SELECTS the text rather than reporting an error — "we've highlighted it, press
 * Ctrl+C" is a working instruction; "copy failed" is not.
 *
 * The status line is `role="status"` in the markup, so the result is announced
 * rather than only shown.
 */
( function ( _s ) {
	const RESET_AFTER = 4000;

	_s( document ).ready( () => {
		const _buttons = _s( '[data-invite-copy]' );

		if ( ! _buttons.el.length ) {
			return;
		}

		_buttons.on( 'click', e => {
			const button = e.currentTarget || e.target;
			const card = button.closest( '[data-invite-link]' );

			if ( ! card ) {
				return;
			}

			const input = card.querySelector( '[data-invite-url]' );

			if ( ! input ) {
				return;
			}

			const status = card.querySelector( '[data-invite-status]' );

			const say = message => {
				if ( status ) {
					status.textContent = message;
					window.setTimeout( () => {
						status.textContent = '';
					}, RESET_AFTER );
				}
			};

			// Select first, unconditionally: it is the fallback instruction AND it gives
			// the click visible feedback even on the success path.
			input.focus();
			input.select();
			input.setSelectionRange( 0, input.value.length );

			if ( ! navigator.clipboard || ! window.isSecureContext ) {
				say( 'Your browser blocked copying — the link is selected, press Ctrl+C.' );

				return;
			}

			navigator.clipboard.writeText( input.value ).then(
				() => say( 'Link copied.' ),
				() => say( 'Your browser blocked copying — the link is selected, press Ctrl+C.' )
			);
		} );
	} );
} )( window._s );
